module.exports = __webpack_public_path__ + "za.svg?9b853c8e417423eca58096f1eedc40da";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/za.svg
// module id = 1229
// module chunks = 27